<div id="divAlarmMain">
  <div class="alarmWidgetRow" style="font-size: 26px;margin-top: 5px;color:yellow">{{message}}</div>
  <div class="alarmWidgetRow" style="font-size: 26px;margin-top: 5px;">{{clockTime}}</div>
  <table class="h-full">
    <tr>
      <td>
        <app-jkcheckbox class="alarmWidgetRow" style="color:aqua;" label="15分鐘鬧鐘"  [(value)]="is15minuteAlert" >
        </app-jkcheckbox>
      </td>
      <td>
        <app-jkcheckbox class="alarmWidgetRow" style="color:aqua;" label="設定時間鬧鐘"   [(value)]="isSpeechAlarm" >
        </app-jkcheckbox>
      </td>
    </tr>
    <tr>
      <td>
        <app-jkcheckbox label="使用azure語音"  [(value)]="isAzureSpeech" >
        </app-jkcheckbox>
        <button mat-flat-button class="btn" [class.btn-success]="true" (click)="queryData()">查設定</button>
      </td>
      <td>
        <h3>{{modes[modeIndex]}}</h3>
      </td>
    </tr>
  </table>


  <textarea class="w-full" rows="6" cols="30" style="font-size: 16px;background: rgb(0,0,0);">
    {{logMessage}}
  </textarea>

  <app-jkgridwin #jkgrid id="jkgrid" class="w-full"  [defaultHeight]="300"
  (afterGridReady)="afterGridReady($event)">
</app-jkgridwin>

</div>
